import { on } from "svelte/events";
import type { Action } from "svelte/action";

export const applyHasSlotContentClass: Action<HTMLSlotElement> = (node: HTMLSlotElement) => {
  const update = (): boolean =>
    node.classList.toggle("--has-slot-content", node.assignedNodes().length > 0);

  update();
  return {
    destroy: on(node, "slotchange", update),
  };
};
